/* eslint-disable jsx-a11y/anchor-is-valid */
import { Route } from "routes/_authenticated/app.kunder.$customerId.facility.$facilityId.separator.$separatorId";
import { useGetSeparator } from "api/separator.api";
import { PageLoader } from "components/PageLoader";
import { SeparatorDetailsTab } from "./SeparatorDetailsTab";
import { SeparatorAssignmentsTab } from "./SeparatorAssignmentsTab";
import { AvskiljareTechnicalInformation } from "./AvskiljareTechnicalInformation";
import { getSeparatorTypeLabel } from "types/separator/separator.helpers";
import { isAvskiljare, SeparatorType } from "types/separator/separator.type";
import { PageHeader } from "components/PageHeader";
import { ErrorScreen } from "components/ErrorScreen";
import { TabMenu } from "../uppdrag/TabMenu";
import { useMemo, useEffect } from "react";
import { scrollToTop } from "helpers/scroll";
import { ProvtagningspunktTechnicalInformation } from "./ProvtagningspunktTechnicalInformation";
import { useHasRightsForFeature } from "api/company.api";
import { OperatorPrivilege } from "types/company.type";

export enum SeparatorPageTab {
  Overview = "oversikt",
  TechnicalInformation = "teknisk-information",
  Kontroller = "historik",
}

export default function SeparatorPage() {
  // tabs

  const { separatorId } = Route.useParams();
  const search = Route.useSearch();
  const separatorIdNum: string = separatorId || "-1";

  const {
    data: separator,
    isLoading,
    isError,
  } = useGetSeparator(Number(separatorIdNum));

  // const separatorLabel = !separator ?  `${getSeparatorTypeLabel(separator)}${
  //         !separator.identifier ? "" : ` - ${separator.identifier}

  // const userRole = userStore(getUserRole);
  const separatorLabel = !separator
    ? ""
    : `${getSeparatorTypeLabel(separator)}${!separator.identifier ? "" : ` - ${separator.identifier}`}`;

  const tabs = [
    { label: "Översikt", value: SeparatorPageTab.Overview },
    isAvskiljare(separator) ||
    separator?.type === SeparatorType.WaterMeasurementPoint
      ? {
          label: "Teknisk information",
          value: SeparatorPageTab.TechnicalInformation,
        }
      : undefined,
    {
      label: "Historik",
      value: SeparatorPageTab.Kontroller,
    },
  ].filter((x) => x !== undefined);

  const currentTab = search.tab ?? SeparatorPageTab.Overview;

  const tabMenuItems = useMemo(
    () =>
      tabs.map((tab) => ({
        label: tab!.label,
        value: tab!.value,
        isActive: currentTab === tab!.value,
        link: {
          search: { tab: tab!.value },
        },
      })),
    [tabs, currentTab],
  );

  useEffect(() => {
    if (separatorLabel) {
      document.title = separatorLabel;
    }
  }, [separatorLabel]);

  useEffect(() => {
    scrollToTop();
  }, [currentTab]);

  const canViewCustomerPage = useHasRightsForFeature(
    OperatorPrivilege.ViewCustomer,
  );

  if (isLoading) {
    return <PageLoader />;
  }
  if (isError || !separator) {
    return <ErrorScreen />;
  }

  return (
    <div className="mb-8">
      <PageHeader
        header={`${separatorLabel}${separator.isDeleted ? " - BORTTAGEN" : ""}`}
        breadCrumbList={[
          {
            label: separator.facility.customer.name,
            link: canViewCustomerPage
              ? {
                  to: "/app/kunder/$customerId",
                  params: {
                    customerId: separator.facility.customer.id.toString(),
                  },
                }
              : undefined,
            iconType: "customer",
          },
          {
            label: separator.facility.name,
            link: {
              to: "/app/kunder/$customerId/facility/$facilityId",
              params: {
                customerId: separator.facility.customer.id.toString(),
                facilityId: separator.facility.id.toString(),
              },
            },
            iconType: "facility",
          },
        ]}
        iconType="separator"
      />
      <TabMenu items={tabMenuItems} />
      {currentTab === SeparatorPageTab.Overview && (
        <SeparatorDetailsTab separator={separator} />
      )}

      {currentTab === SeparatorPageTab.TechnicalInformation &&
        isAvskiljare(separator) && (
          <AvskiljareTechnicalInformation separator={separator} />
        )}

      {currentTab === SeparatorPageTab.TechnicalInformation &&
        separator.type === SeparatorType.WaterMeasurementPoint && (
          <ProvtagningspunktTechnicalInformation separator={separator} />
        )}

      {currentTab === SeparatorPageTab.Kontroller && (
        <SeparatorAssignmentsTab separator={separator} />
      )}
    </div>
  );
}
